var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.19 4.218a2.925 2.925 0 0 0-3.198.66l-.275.275-1.396 1.396-7.993 7.993-.001.002a.498.498 0 0 0-.133.237l-1.178 4.595a.5.5 0 0 0 .608.608l4.603-1.18a.5.5 0 0 0 .23-.131l.003-.004 7.99-7.989v-.001l.002-.001 1.393-1.394.002-.001.001-.001.274-.274a2.926 2.926 0 0 0 .025-4.154l-.354.353.353-.354a2.926 2.926 0 0 0-.957-.635zM9.105 17.609l7.284-7.284-2.715-2.715-7.287 7.286 2.718 2.713zm-3.159-1.74l2.187 2.183-2.94.754.753-2.937zm8.435-8.966l2.715 2.715.69-.689-2.716-2.715-.69.689zm4.11 1.318a1.928 1.928 0 0 0-.052-2.66 1.926 1.926 0 0 0-2.661-.053l2.713 2.713z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "edit.4bd1281f62510904ab92befab53931f0.svg";